$(function () {
  $('.media-with-text-tabs .tab').click(function () {
    $('.media-with-text-tabs .tab').removeClass('active');
    $(this).addClass('active');
    $('.media-with-text-tabs-item').removeClass('active');
    $('.media-with-text-tabs-item').eq($(this).index()).addClass('active');
  });

  function activateAccordionItem($section, index) {
    var $items = $section.find('.iwa-accordion-item');
    var $images = $section.find('.iwa-image-item');
    var normalizedIndex = parseInt(index, 10);

    if (Number.isNaN(normalizedIndex)) return;

    $items.removeClass('active');
    $images.removeClass('active');

    $items.filter('[data-index="' + normalizedIndex + '"]').addClass('active');
    $images.filter('[data-index="' + normalizedIndex + '"]').addClass('active');
  }

  // Delegated binding: single listener for all current/future accordion sections.
  $(document).on('click', '.image-with-accordion .iwa-accordion-item', function () {
    var $item = $(this).closest('.iwa-accordion-item');
    var $section = $(this).closest('.image-with-accordion');
    activateAccordionItem($section, $item.data('index'));
  });
});